import { createSlice } from "@reduxjs/toolkit";
import { ToastInfo } from "@/shared/models/ToastInfo";
import { RootState } from "./store";
import { Terminal } from "@/shared/models/Terminal";
import { Product } from "@/shared/models/Product";
import { CountryRegionDomain } from "@/shared/models/CountryRegionDomain";
import { ToastInfoType } from "@/shared/Enums";
import { FaultCode } from "@/shared/models/FaultCode";

const initialState = {
  toastInfo: { isShow: false, text: "", type: ToastInfoType.Info } as ToastInfo,
  loadPanelVisible: false,
  loadingCounter: 0,
  terminals: [] as Terminal[],
  products: [] as Product[],
  countryRegionDomains: [] as CountryRegionDomain[],
  faultCodes: [] as FaultCode[],
};

const shareSlice = createSlice({
  name: "share",
  initialState: initialState,
  reducers: {
    setToastError(state, action) {
      state.toastInfo = { text: action.payload, isShow: true, type: ToastInfoType.Error };
    },
    setToastSuccess(state, action) {
      state.toastInfo = { text: action.payload, isShow: true, type: ToastInfoType.Success };
    },
    setToastWarning(state, action) {
      state.toastInfo = { text: action.payload, isShow: true, type: ToastInfoType.Warning };
    },
    setToastInfo(state, action) {
      state.toastInfo = { text: action.payload, isShow: true, type: ToastInfoType.Info };
    },
    clearToastError(state) {
      state.toastInfo = { text: "", isShow: false, type: ToastInfoType.Error };
    },
    setLoadPanelVisible(state, action) {
      if (action.payload) {
        shareSlice.caseReducers.clearToastError(state);
      }

      state.loadPanelVisible = action.payload;
    },
    beginLoading(state) {
      if (state.loadingCounter === 0) {
        shareSlice.caseReducers.clearToastError(state);
      }

      state.loadingCounter += 1;
      state.loadPanelVisible = true;
    },
    endLoading(state) {
      state.loadingCounter = Math.max(0, state.loadingCounter - 1);
      state.loadPanelVisible = state.loadingCounter > 0;
    },
    setTerminals(state, action) {
      state.terminals = action.payload;
    },
    setProducts(state, action) {
      state.products = action.payload;
    },
    setCountryRegionDomains(state, action) {
      state.countryRegionDomains = action.payload;
    },
    setFaultCodes(state, action) {
      state.faultCodes = action.payload;
    },
  },
});

export const {
  setToastError,
  setToastSuccess,
  setToastWarning,
  setToastInfo,
  clearToastError,
  setLoadPanelVisible,
  beginLoading,
  endLoading,
  setTerminals,
  setProducts,
  setCountryRegionDomains,
  setFaultCodes,
} = shareSlice.actions;
export const shareReducer = shareSlice.reducer;

// Selector
export const selectToastInfo = (state: RootState) => state.share.toastInfo as ToastInfo;
export const selectLoadPanelVisible = (state: RootState) => state.share.loadPanelVisible as boolean;
export const selectLoadingCounter = (state: RootState) => state.share.loadingCounter as number;
export const selectTerminals = (state: RootState) => state.share.terminals as Terminal[];
export const selectProducts = (state: RootState) => state.share.products as Product[];
export const selectCountryRegionDomains = (state: RootState) => state.share.countryRegionDomains as CountryRegionDomain[];
export const selectFaultCodes = (state: RootState) => state.share.faultCodes as FaultCode[];
